import React from 'react';
import { observer } from 'mobx-react-lite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Content, Dialog, Text, Wrapper, VehicleLink,
} from './styles';
import Button from '../common/Button';
import useStores from '../../hooks/useStore';

const VinDecodeDialog = observer(({ populateYearMakeModel }) => {
  const { UIStore } = useStores();
  const { setShowError, errorMessage, multiVehicles } = UIStore;

  const {
    year, make, model, vin,
  } = UIStore;

  if (!multiVehicles || !vin || (year && make && model)) {
    return null;
  }

  return (
    <Wrapper>
      <Dialog>
        <Content>
          <FontAwesomeIcon icon="exclamation-circle" color="#c80005" size="3x" />
          <Text>Multiple vehicles were found</Text>
          {multiVehicles.map((item, i) => (

            <VehicleLink key={i} onClick={() => populateYearMakeModel(item)}>
              {item.vehicleYear}
              {' '}
              {item.vehicleBrand}
              {' '}
              {item.vehicleModel}
            </VehicleLink>

          ))}
          <Button onClick={() => setShowError(false)}>Close</Button>
        </Content>
      </Dialog>
    </Wrapper>
  );
});

export default VinDecodeDialog;
